import { styled } from '@material-ui/core';

export const SendoutNoteContainer = styled('div')(({ theme }) => ({
  marginBottom: theme.spacing(4)
}));
